let w_resizeTimer,
    w_scrollTimer,
    w_lang;

const w_base = '/',
      w_myScreen = {},
      w_myBrowser = {
        engine: '',
        version: 0,
        os: ''
      },
      w_duration = {
        short: 250,
        mid: 500,
        long: 2500
      };

window.addEventListener('DOMContentLoaded',function()
{
    // get language from HTML
    w_lang = document.documentElement.lang;
    const fadeElements = document.body.querySelectorAll('.w__fade-in');
    const myGoogleMap = document.getElementById('w--google-map');

    // open filter if set
    if(sessionStorage.getItem('filter-closed') === "1")
    {
        document.body.classList.remove('w__mobile--filter-active');
    }

    // get os, browser engine and version
    get_browser();

    // get screen size
    get_screenSize();

    // fade in main column after 1 sec
    if(w_myScreen.layout === 'desktop')
    {
        for(let i = 0; i < fadeElements.length; i++)
        {
            fadeElements[i].style.opacity = '0';
            fadeElements[i].style.transform = 'translateY(100px)';
        }
        setTimeout(() =>
        {
            for(let i = 0; i < fadeElements.length; i++)
            {
                fadeElements[i].classList.add('w__transition');
                fadeElements[i].offsetHeight;
                fadeElements[i].removeAttribute('style');
            }
        },1000);
    }

    // add event listener
    document.body.addEventListener('click',e =>
    {
        let el = e.target;

        if(el.closest('.w__js-button'))
        {
            el = el.closest('.w__js-button');
        }

        if(el.classList.contains('w__mobile--menu-button'))
        {
            document.body.classList.toggle('w__mobile--menu-active');
        }
        else if(el.classList.contains('w__mobile--filter-button'))
        {
            document.body.classList.toggle('w__mobile--filter-active');
            if(document.body.classList.contains('w__mobile--filter-active'))
            {
                sessionStorage.removeItem('filter-closed');
                document.documentElement.scrollTo(0,0);
            }
            else
            {
                sessionStorage.setItem('filter-closed', "1");
            }
        }
        else if(el.classList.contains('w__js-button'))
        {
            switch(el.dataset.f)
            {
                case 'close-lightbox':
                    Lightbox.close(el, myGoogleMap);
                    break;

                case 'highlight-date':
                    if(el.href)
                    {
                        highlight_dates(el);
                    }
                    break;

                case 'lightbox':
                    e.preventDefault();
                    new Lightbox(el);
                    break;

                case 'load-month':
                    e.preventDefault();
                    do_request({
                        f: 'load-next-month',
                        url: el.href
                    }).then(r => {
                        el.insertAdjacentHTML('beforebegin',r['html'].toString());
                        el.remove();
                    }).catch(error => {
                        console.error(error);
                    })
                    break;

                case 'video':
                    e.preventDefault();
                    show_video(el);
                    break;

                case 'view-bg':
                    if(document.body.classList.contains('w__bg--show'))
                    {
                        // if bg contains google map do not remove it on interaction
                        if(!myGoogleMap)
                        {
                            document.body.classList.remove('w__bg--show');
                        }
                    }
                    else
                    {
                        document.body.classList.add('w__bg--show');
                        if(myGoogleMap)
                        {
                            Lightbox.add_close(document.body);
                        }
                    }
                    break;

                default:
                    alert("Unbekannte Funktion: " + el.dataset.f);
            }
        }
    });

    // add google map
    if(myGoogleMap)
    {
        //load_googlemapApi(myGoogleMap);
    }
    else
    {
        const bg = document.getElementById('w--bg');
        if(bg)
        {
            new Slideshow(bg);
        }
    }

    // call lightboxes directly
    if(document.body.dataset.lightbox)
    {
        let callEl,
            callId = document.body.dataset.targetId

        if(callId)
        {
            switch(document.body.dataset.lightbox)
            {
                case "form":
                    callEl = document.body.querySelector('.w__js-button[data-form-id=\"' + callId + '\"]');
                    if(!callEl)
                    {
                        callEl = document.createElement('span');
                        callEl.dataset.f = 'lightbox';
                        callEl.dataset.lightboxType = 'form';
                        callEl.dataset.formId = callId;
                        callEl.dataset.href = '';
                    }
                    break;

                case "video":
                    callEl = document.body.querySelector('.w__video--link[data-video-id=\"' + callId + '\"]');
                    break;

                case "gallery":
                    callEl = document.body.querySelector('.w__gallery--preview[data-gallery-id=\"' + callId + '\"]');
                    break;
            }

            if(callEl)
            {
                new Lightbox(callEl);
            }
        }
    }
});

/*
const load_googlemapApi = function(parentEl)
{
    const myLibrary = document.createElement('script');
    myLibrary.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA0V3ehMtm77qoHY8nVN3ad5CpNdNfMDEg';
    myLibrary.onload = function()
    {
        build_googlemap(parentEl);
    };
    document.head.appendChild(myLibrary);
}

const build_googlemap = function(myMapCanvas)
{
    const latLng = {lat: parseFloat(myMapCanvas.dataset.lat), lng: parseFloat(myMapCanvas.dataset.long)},
          latLngMarker = {lat: parseFloat(myMapCanvas.dataset.latMarker), lng: parseFloat(myMapCanvas.dataset.longMarker)},
          zoomLevel = parseInt(myMapCanvas.dataset.zoom);

    const myOptions = {
        zoom: zoomLevel,
        center: latLng,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        zoomControl: true,
        draggable: true,
        styles:
            [{
                featureType: 'all', stylers:
                    [{
                        saturation: -100
                    },
                        {
                            gamma: 0.80
                        }
                    ]},
                {
                    featureType: 'water',
                    stylers:
                        [{
                            color: '#7692FF'
                        }]},
                {
                    featureType: 'poi.park',
                    stylers:
                        [{
                          color: '#7DCFB6'
                        }]},
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers:
                        [{
                            visibility: 'off'
                        }]
                }]
    };
    const map = new google.maps.Map(myMapCanvas, myOptions);
    const marker = new google.maps.Marker(
        {
            position: latLngMarker,
            map: map,
            icon: {url: w_base + 'pix/marker.' + (w_myBrowser.engine === 'trident' ? 'png' : 'svg'), width: '100px'}
        });
    map.setOptions({disableDefaultUI: true});
    marker.setMap(map);
};
 */

const do_request = function(myData)
{
    if(myData.f)
    {
        document.documentElement.classList.add('w__waiting');

        return new Promise(function(resolve, reject)
        {
            const myRequest = new XMLHttpRequest();
            myRequest.onreadystatechange = () =>
            {
                if(myRequest.readyState === 4)
                {
                    document.documentElement.classList.remove('w__waiting');
                    if(myRequest.status === 200 && myRequest.response)
                    {
                        let r = (typeof myRequest.response === 'string')
                            ? JSON.parse(myRequest.response) // fix for IE 11 that doesn't honor responseType
                            : myRequest.response;

                        if(r['ok'] === 'OK')
                        {
                            resolve(r);
                        }
                        else
                        {
                            reject(r);
                        }
                    }
                    else
                    {
                        reject({error: myRequest.status});
                    }
                }
            };

            myRequest.onerror = () =>
            {
                document.documentElement.classList.remove('w__waiting');
                reject({error: 'undefined error'});
            };

            myRequest.ontimeout = () =>
            {
                document.documentElement.classList.remove('w__waiting');
                reject({error: 'timeout'});
            };

            myRequest.open("POST", w_base + 'index.php');
            myRequest.timeout = 10000;
            myRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=utf-8");
            myRequest.setRequestHeader("Accept", "application/json");
            myRequest.responseType = 'json';
            myRequest.send('json=' + encodeURIComponent(JSON.stringify(myData)));
        });
    }
};

class Form
{
    constructor(elData, parentEl)
    {
        this.formId = elData.formId;
        this.parentEl = parentEl;

        do_request({
            f: 'form',
            action: 'build',
            formId: parseInt(this.formId),
            eventId: elData.eventId ? parseInt(elData.eventId) : null,
            projectId: elData.projectId ? parseInt(elData.projectId) : null,
            projectDateId: elData.projectDateId ? parseInt(elData.projectDateId) : null,
            moduleId: elData.moduleId ? parseInt(elData.moduleId) : null,
            publicationId: elData.publicationId ? parseInt(elData.publicationId) : null
        }).then(r => {
            this.build_form(r);
        }).catch(r => {
            this.inject_container(r['html']);
        });
    }

    build_form(r)
    {
        this.inject_container(r['html']);
        this.form = document.getElementById('w--form-' + this.formId);
        this.submitButton = this.parentEl.querySelector('.w__form--submit');

        if(this.form && this.form.dataset.path)
        {
            Lightbox.push_url(w_base + this.form.dataset.path);
        }

        if(this.form && this.submit)
        {
            this.form.addEventListener('submit',e =>
            {
                e.preventDefault();
                this.submitButton.classList.add('none');

                if(this.check_required())
                {
                    this.submit();
                }
                else
                {
                    this.submitButton.classList.remove('none');
                }
            });

            this.form.addEventListener('focus',e =>
            {
                const el = e.target,
                      parentEl = el.closest('.w__input--container')

                if(parentEl &&
                  (el.classList.contains('w__input') ||
                   el.classList.contains('w__input--checkbox') ||
                   el.classList.contains('w__input--radio')))
                {
                    parentEl.classList.remove('w__input--error');
                }
            },true);

            if((this.formId === '7' || this.formId === '10' || this.formId === '11') &&
               this.form.querySelector('input[name="amount"]'))
            {
                this.form.querySelector('input[name="amount"]')
                         .addEventListener('change',e => {
                             this.change_nameInputs(e.target);
                         });
            }
        }
        else
        {
            alert("Form or submit button missing");
        }
    }

    change_nameInputs(el)
    {
        let amount = parseInt(el.value) - 1;
        const nameFields = this.form.querySelectorAll('.w__form--extra-name');

        if(parseInt(el.value) > parseInt(el.max))
        {
            el.closest('.w__input--container').classList.add('w__input--error');
            amount = parseInt(el.max) - 1;
        }
        else if(parseInt(el.value) < parseInt(el.min))
        {
            el.closest('.w__input--container').classList.add('w__input--error');
            amount = parseInt(el.min) - 1;
        }
        else
        {
            el.closest('.w__input--container').classList.remove('w__input--error');
        }

        if(amount >= 0 && amount !== nameFields.length)
        {
            let fieldset = this.form.querySelector('.w__form--extra-name-fieldset');
            if(amount <= 0 && fieldset)
            {
                fieldset.remove();
            }
            else if(amount > nameFields.length)
            {
                if(!fieldset)
                {
                    fieldset = document.createElement('fieldset');
                    fieldset.className = 'w__form--fieldset w__form--extra-name-fieldset';

                    const fieldsetLabel = document.createElement('legend');
                    fieldsetLabel.classList.add('w__form--fieldset-caption');
                    fieldsetLabel.textContent = 'Weitere Personen';

                    fieldset.appendChild(fieldsetLabel);
                    this.form.querySelector('fieldset:last-of-type')
                             .insertAdjacentElement('beforebegin', fieldset);
                }

                for(let i=nameFields.length; i<amount; i++)
                {
                    fieldset.appendChild(this.add_nameInput(i));
                }
            }
            else if(amount <= nameFields.length)
            {
                for(let i=nameFields.length; i>amount; i--)
                {
                    nameFields[i-1].closest('p').remove();
                }
            }
        }
    }

    add_nameInput(i)
    {
        const p = document.createElement('p');
        p.className = 'w__input--container w__input--required';

        const label = document.createElement('label');
        label.classList.add('w__input--label');
        label.setAttribute('for','extraname-' + i.toString());
        label.textContent = (i + 2).toString() + '. Name';
        p.appendChild(label);

        const input = document.createElement('input');
        input.className = 'w__input w__input--text w__form--extra-name';
        input.id = 'extraname-' + i.toString();
        input.name = 'name[' + i.toString() + ']';
        input.dataset.required = '1';
        p.appendChild(input);

        return p;
    }

    check_required()
    {
        let ok = true;
        const fields = this.form.querySelectorAll('input[data-required="1"],select[data-required="1"],textarea[data-required="1"]');
        for(let i=0; i<fields.length; i++)
        {
            const parentEl = fields[i].closest('.w__input--container');

            if(this.check_value(fields[i]) === false)
            {
                if(parentEl)
                {
                    parentEl.classList.add('w__input--error');
                    if(ok === true)
                    {
                        ok = false;
                        parentEl.closest('.w__form--fieldset').scrollIntoView();
                    }
                }
            }
            else if(fields[i].dataset.minAge)
            {
                const warning = document.getElementById('w--' + fields[i].name + '-warning');
                if(warning)
                {
                    warning.remove();
                }

                const minAge = parseInt(fields[i].dataset.minAge);
                let birthDate = new Date(fields[i].value),
                    today = new Date();
                birthDate = birthDate.setFullYear(birthDate.getFullYear() + minAge);
                today = today.setFullYear(today.getFullYear());

                if(parentEl &&
                   birthDate > new Date())
                {
                    parentEl.classList.add('w__input--error');
                    if(ok === true)
                    {
                        ok = false;
                        parentEl.closest('.w__form--fieldset').scrollIntoView();
                    }
                    const myWarning = document.createElement('p');
                    myWarning.textContent = 'Das Mindestalter beträgt ' + minAge + ' Jahre.';
                    myWarning.classList.add('w__input--error');
                    myWarning.id = 'w--' + fields[i].name + '-warning';
                    parentEl.insertAdjacentElement('afterend',myWarning);
                }
            }
        }

        // newsletter subscription needs at least one selected distribution list
        if(this.formId === '6')
        {
            const checkNewsletter = this.form.querySelector('input[name="newsletter"]'),
                  checkProgramm = this.form.querySelector('input[name="programm_email"]');

            if(!checkNewsletter.checked && !checkProgramm.checked)
            {
                ok = false;
                checkNewsletter.closest('.w__input--container').classList.add('w__input--error');
                checkProgramm.closest('.w__input--container').classList.add('w__input--error');
            }
        }

        return ok;
    }

    check_value(el)
    {
        let ok;

        switch(el.type)
        {
            case 'radio':
                ok = false;
                const radios = el.closest('.w__input--radio-container').querySelectorAll('.w__input--radio[name="' + el.name + '"]');
                for(let i=0; i<radios.length; i++)
                {
                    if(radios[i].checked)
                    {
                        ok = true;
                    }
                }
                break;

            case 'checkbox':
                ok = !!el.checked;
                break;

            case 'email':
                ok = Form.valid_email(el.value.trim());
                break;

            case 'number':
                ok = ((el.min && parseInt(el.value) >= parseInt(el.min)) ||
                     (!el.min && parseInt(el.value) > 0));
                break;

            default:
                ok = !!el.value.trim();
                break;
        }

        return ok;
    }

    submit()
    {
        let el,
            data = {};
        const fields = this.form.querySelectorAll('input,select,textarea');

        for(let i=0; i<fields.length; i++)
        {
            el = fields[i];
            switch(el.type)
            {
                case 'radio':
                case 'checkbox':
                    if(el.checked)
                    {
                        data[el.name] = el.value;
                    }
                    break;

                default:
                    data[el.name] = el.value.trim();
                    break;
            }
        }

        do_request({
            f: 'form',
            action: 'submit',
            formId: this.formId,
            data: data
        }).then(r => {
            this.container.innerHTML = r['html'].toString();
            window.scrollTo(0,0);
        }).catch(r => {
            this.container.innerHTML = r['html'];
            window.scrollTo(0,0);
        })
    }

    inject_container(html)
    {
        this.container = document.createElement('div');
        this.container.classList.add('w__lightbox--container');
        this.container.innerHTML = html;
        this.parentEl.appendChild(this.container);
    }

    static valid_email(email)
    {
        const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;
        return reg.test(email);
    };
}

class Search
{
    constructor(lb)
    {
        this.lb = lb;
        do_request({
            f: 'search',
            action: 'build'
        }).then(r => {
            this.build_search(r);
        }).catch(r => {
            this.inject_container(r['html']);
        });
    }

    build_search(r)
    {
        this.inject_container(r['html']);
        this.search = document.getElementById('w--search');
        let searchInput = document.getElementById('w--search-input'),
            searchSelect = document.getElementById('w--search-select');

        if(this.search && searchInput && searchSelect)
        {
            searchInput.focus();
            searchInput.select();

            this.search.addEventListener('submit',e =>
            {
                e.preventDefault();

                if(searchInput.value.trim().length >= 2)
                {
                    this.do_search(searchInput.value.trim(), parseInt(searchSelect.value));
                }
            });

            searchSelect.addEventListener('change',() =>
            {
                if(searchInput.value.trim().length >= 2)
                {
                    this.do_search(searchInput.value.trim(), parseInt(searchSelect.value));
                }
            });
        }
    }

    do_search(term, tableId)
    {
        do_request({
            f: 'search',
            action: 'search',
            data: {
                searchTerm: term,
                searchTableId: tableId
            }
        }).then(r => {
            this.inject_container(r['html'],'w--search-result');
        }).catch(r => {
            this.inject_container(r['html'],'w--search-result');
        });
    }

    inject_container(html, id)
    {
        if(id &&
           document.getElementById(id))
        {
            document.getElementById(id).innerHTML = html;
        }
        else
        {
            const container = document.createElement('div');
            container.classList.add('w__lightbox--container');
            if(id)
            {
                container.id = id;
                container.classList.add('w__lightbox--search-result');
            }
            container.innerHTML = html;
            this.lb.appendChild(container);
        }
    }
}

class Lightbox
{
    constructor(el)
    {
        this.parentEl = el;
        this.lb = this.build_lightbox();

        const returnUrl = location.pathname.match(/informationen\/mediathek/)
            ? w_base + 'informationen/mediathek'
            : location.pathname;

        switch(el.dataset.lightboxType)
        {
            case 'form':
                window.scrollTo(0,0);
                new Form(el.dataset, this.lb);
                break;

            case 'gallery':
                this.image = undefined;
                this.activeEl = undefined;
                this.add_navigation('.w__gallery--item');
                this.add_captionElement();
                Lightbox.adjust_height();
                this.load_image(this.parentEl.querySelector('.w__tile--image'));
                break;

            case 'search':
                window.scrollTo(0,0);
                new Search(this.lb);
                break;

            case 'video':
                this.add_video();
                break;
        }

        Lightbox.add_close(this.lb, returnUrl);
        Lightbox.push_url(this.parentEl.dataset.url);
    }

    static push_url(url)
    {
        if(url)
        {
            window.history.replaceState({v: url}, document.title, url);
        }
    }

    static switch_logoColor(filenameAdd)
    {
        const myLogo = document.getElementById('w--logo');
        if(myLogo)
        {
            myLogo.src = w_base + 'pix/logo_image' + filenameAdd + '.svg';
        }
    }

    static adjust_height()
    {
        if(w_myScreen.layout !== 'desktop')
        {
            const myLightbox = document.getElementById('w--lightbox');
            if(myLightbox && myLightbox.querySelector('.w__bg--item-caption'))
            {
                myLightbox.style.height = w_myScreen.y.toString() + 'px';
            }
        }
    }

    build_lightbox()
    {
        // stop showing mobile menu (newsletter form call on mobile)
        document.body.classList.remove('w__mobile--menu-active');

        // remove exisiting lightbox
        if(document.getElementById('w--lightbox'))
        {
            document.getElementById('w--lightbox').remove();
        }

        const lb = document.createElement('div');
        lb.id = 'w--lightbox';
        lb.classList.add('w__lightbox');
        if(this.parentEl.dataset.lightboxType === 'form' ||
           this.parentEl.dataset.lightboxType === 'search')
        {
            lb.classList.add('w__lightbox--form');
            Lightbox.switch_logoColor('_color');
        }
        document.body.classList.add('w__lightbox--active');
        document.body.appendChild(lb);

        document.getElementById('w--main').classList.add('none');

        return lb;
    }

    add_captionElement()
    {
        this.caption = document.createElement('div');
        this.caption.classList.add('w__bg--item-caption');
        this.lb.appendChild(this.caption);
    }

    add_navigation(elClass)
    {
        if(this.parentEl.querySelectorAll(elClass).length > 1)
        {
            const prev = document.createElement('a');
            prev.classList.add('w__lightbox--nav');
            prev.classList.add('prev');
            prev.addEventListener('click', () => {
                let newEl = this.activeEl.previousSibling;
                if(!newEl)
                {
                    newEl = this.parentEl.lastChild;
                }
                this.load_image(newEl);
            });
            this.lb.appendChild(prev);

            const next = document.createElement('a');
            next.classList.add('w__lightbox--nav');
            next.classList.add('next');
            next.addEventListener('click', () => {
                let newEl = this.activeEl.nextSibling;
                if(!newEl)
                {
                    newEl = this.parentEl.firstChild;
                }
                this.load_image(newEl);
            });

            this.lb.appendChild(prev);
            this.lb.appendChild(next);
        }
    }

    add_video()
    {
        const videoContainer = document.createElement('div'),
              iFrame = get_iFrame(get_iFrameSrc(this.parentEl),'w__video--iframe');

        videoContainer.classList.add('w__lightbox--video-container');
        videoContainer.appendChild(iFrame);

        this.lb.appendChild(videoContainer);
    }

    load_image(el)
    {
        document.documentElement.classList.add('w__waiting');
        if(this.image)
        {
            this.image.remove();
            this.caption.innerHTML = '';
        }
        this.activeEl = el;
        const src = el.dataset.href ? el.dataset.href : el.href,
              newImage = new Image();
        let availableWidth = (w_myScreen.layout === 'desktop') ? w_myScreen.x - 300 : w_myScreen.x,
            awavailableHeight = w_myScreen.y;

        newImage.src = adjust_imagePath(src,
                                        parseInt(el.dataset.width),
                                        parseInt(el.dataset.height),
                                        availableWidth,
                                        awavailableHeight);

        newImage.className = 'w__lightbox--image';
        newImage.addEventListener('load',() =>
        {
            document.documentElement.classList.remove('w__waiting');
            this.caption.innerHTML = '<strong>' + el.dataset.title + '</strong> ' + el.dataset.subtitle;
            this.lb.appendChild(newImage);
            this.image = newImage;
        });
    }

    static add_close(parentEl, url)
    {
        const closeContainer = document.createElement('div'),
              closeX = document.createElement('span');

        closeContainer.classList.add('w__lightbox--close');
        closeContainer.classList.add('w__js-button');
        closeContainer.dataset.f = 'close-lightbox';
        closeContainer.dataset.url = url ? url : document.documentURI;
        closeContainer.appendChild(closeX);

        closeX.classList.add('w__lightbox--close-text');
        closeX.textContent = "X";

        parentEl.appendChild(closeContainer);
    }

    static close(el, myGoogleMap)
    {
        document.getElementById('w--main').classList.remove('none');
        const lb = document.getElementById('w--lightbox');

        if(lb)
        {
            document.body.classList.remove('w__lightbox--active');
            if(el.dataset.url)
            {
                Lightbox.push_url(el.dataset.url);
            }
            Lightbox.switch_logoColor('');
            lb.remove();
        }
        else if(myGoogleMap)
        {
            el.remove();
            document.body.classList.remove('w__bg--show');
        }
    }
}

class Slideshow
{
    constructor(parentEl)
    {
        this.interval = 10000;
        this.slides = parentEl.querySelectorAll('.w__bg--item');
        if(this.slides.length > 1 &&
           w_myBrowser.mobile === false)
        {
            this.activeSlideNo = 0;
            setTimeout(() =>
            {
                this.next();
            }, this.interval - w_duration['long'])
        }
    }

    next()
    {
        let nextSlideNo = this.activeSlideNo + 1;

        if(nextSlideNo >= this.slides.length)
        {
            nextSlideNo = 0;
        }

        const lazyImage = this.slides[nextSlideNo].querySelector('.w__bg--image-load');

        if(lazyImage)
        {
            this.load(lazyImage, nextSlideNo);
        }
        else
        {
            this.change(nextSlideNo);
        }
    }

    load(loadEl, nextSlideNo)
    {
        const newImage = new Image();
        newImage.src = adjust_imagePath(loadEl.href, this.slides[nextSlideNo].getBoundingClientRect()['width']);
        newImage.alt = loadEl.dataset.alt;
        newImage.title = loadEl.dataset.title;
        newImage.className = 'w__bg--image';
        newImage.addEventListener('load',() =>
        {
            this.slides[nextSlideNo].insertAdjacentElement('afterbegin', newImage);
            loadEl.remove();
            newImage.offsetHeight;
            this.change(nextSlideNo);
        });
    }

    change(nextSlideNo)
    {
        this.slides[this.activeSlideNo].classList.remove('active');
        this.slides[nextSlideNo].classList.add('active');
        this.activeSlideNo = nextSlideNo;
        setTimeout(() => {
            this.next();
        }, this.interval)
    }
}

const get_iFrame = function(mySrc, myClass)
{
    const myIframe = document.createElement('iframe');
    myIframe.src = mySrc;
    myIframe.classList.add(myClass);
    myIframe.frameborder = 0;
    myIframe.allowfullscreen = 1;
    myIframe.setAttribute('allow', 'autoplay; fullscreen');
    return myIframe;
};

const get_iFrameSrc = function(el)
{
    let url = el.href;
    switch(el.dataset.type)
    {
        case 'youtube':
            url = 'https://www.youtube-nocookie.com/embed/' +
                el.dataset.code +
                '?showinfo=0' +
                '&controls=1' +
                '&fs=1' +
                '&rel=0' +
                '&hl=de' +
                '&autoplay=1' +
                '&modestbranding=1' +
                '&showsearch=0'
            break;
        case 'vimeo':
            url = 'https://player.vimeo.com/video/' + el.dataset.code + '?autoplay=1&badge=0&byline=0&portrait=0&title=0';//&dnt=1';
            break;

        default:
            alert('Unknown video type');
    }
    return url;
}

const show_video = function(el)
{
    const p = el.closest('p');
    const iFrame = get_iFrame(get_iFrameSrc(el),'w__video--iframe');
    p.innerHTML = '';
    p.classList.add('w__video--link');
    p.appendChild(iFrame);
};

/**
 * adjust path (size) for dynamically loaded images
 *
 * @param imgSrc
 * @param sizeX (max width of image)
 * @param sizeY (max height of image)
 * @param tarX (width of parent element)
 * @param tarY (height of parent element)
 * @returns {*}
 */
const adjust_imagePath = function(imgSrc, sizeX, sizeY, tarX, tarY)
{
    let targetPath,
        size,
        tar;

    // gallery
    if(sizeX && sizeY && tarX && tarY)
    {
        // height is limit
        if(sizeY / (sizeX / tarX) > tarY)
        {
            tar = tarY * w_myScreen.highDpi;
            size = sizeY;
        }
        // width is limit
        else
        {
            tar = tarX * w_myScreen.highDpi;
            size = sizeX;
        }

        if(size * .25 >= tar)
        {
            targetPath = '25';
        }
        else if(size * .5 >= tar)
        {
            targetPath = '50';
        }
        else if(size * .75 >= tar)
        {
            targetPath = '75';
        }
        else
        {
            targetPath = '100';
        }
        imgSrc = imgSrc.replace('/gallery/100/', '/gallery/' + targetPath + '/');
    }
    // background
    else
    {
        sizeX *= w_myScreen.highDpi;
        if(w_myScreen.orientation === 'landscape')
        {
            if(sizeX <= 960)
            {
                targetPath = 'l960';
            }
            else if(sizeX <= 1280)
            {
                targetPath = 'l1280';
            }
            else if(sizeX <= 1600)
            {
                targetPath = 'l1600';
            }
            else if(sizeX <= 1920)
            {
                targetPath = 'l1920';
            }
            else
            {
                targetPath = 'l2560';
            }
        }
        else
        {
            if(sizeX <= 500)
            {
                targetPath = 'p800';
            }
            else if(sizeX <= 750)
            {
                targetPath = 'p1200';
            }
            else if(sizeX <= 1000)
            {
                targetPath = 'p1600';
            }
            else
            {
                targetPath = 'p2000';
            }
        }
        imgSrc = imgSrc.replace('/bg/l1920/', '/bg/' + targetPath + '/');
    }
    return imgSrc;
};

/**
 * analyze browser engine, os and mobile
 */
const get_browser = function()
{
    w_myBrowser.mobile = false;

    if(navigator.vendor && navigator.vendor.match(/google/i))
    {
        w_myBrowser.engine = 'blink';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*chrome\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.vendor && navigator.vendor.match(/apple/i))
    {
        w_myBrowser.engine = 'webkit';
        w_myBrowser.version = parseFloat(navigator.userAgent.replace(/.*version\/([1-9][0-9]*(\.[1-9])?).*/i,'$1'));
    }
    else if(navigator.userAgent.match(/firefox\//i))
    {
        w_myBrowser.engine = 'gecko';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*firefox\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/edge\//i))
    {
        w_myBrowser.engine = 'edgehtml';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*edge\/([1-9][0-9]*)\..*/i,'$1'));
    }
    else if(navigator.userAgent.match(/trident\//i))
    {
        w_myBrowser.engine = 'trident';
        w_myBrowser.version = parseInt(navigator.userAgent.replace(/.*trident\/([1-9][0-9]*)\..*/i,'$1')) + 4;
    }

    switch(navigator.platform.toLowerCase())
    {
        case 'win32':
            w_myBrowser.os = 'windows';
            break;

        case 'macintel':
            // detect iOS on iPadOS/Safari 13
            if(navigator.maxTouchPoints > 1)
            {
                w_myBrowser.os = 'ios';
                w_myBrowser.mobile = true;
            }
            else
            {
                w_myBrowser.os = 'osx';
            }
            break;

        case 'ipad':
        case 'iphone':
            w_myBrowser.os = 'ios';
            w_myBrowser.mobile = true;
            break;

        default:
            if(navigator.userAgent.match(/android/i))
            {
                w_myBrowser.os = 'android';
                w_myBrowser.mobile = true;
            }
            else if(navigator.platform.match(/linux/i))
            {
                w_myBrowser.os = 'linux';
            }
    }
};

/**
 * returns element dimensions and positions
 *
 * @param el
 * @returns {ClientRect | DOMRect}

 const get_elementInfo = function(el)
 {
    return el.getBoundingClientRect(document.body);
};
 */

/**
 * Measures and stores various screen parameters
 */
const get_screenSize = function()
{
    // pixel density
    w_myScreen.highDpi = window.devicePixelRatio ? window.devicePixelRatio : 1;
    if(w_myScreen.highDpi > 2)
    {
        w_myScreen.highDpi = 2;
    }

    // screen size
    if(w_myBrowser.mobile === true)
    {
        w_myScreen.x = window.innerWidth;
        w_myScreen.y = window.innerHeight;
    }
    else
    {
        w_myScreen.x = document.body.clientWidth;
        w_myScreen.y = window.innerHeight;
    }

    if(window.matchMedia('(max-width: 600px)').matches)
    {
        w_myScreen.layout = 'smartphone';
    }
    else if(window.matchMedia('(max-width: 990px)').matches)
    {
        w_myScreen.layout = 'tablet';
    }
    else
    {
        w_myScreen.layout = 'desktop';
    }

    if(window.matchMedia('(orientation: portrait)').matches)
    {
        w_myScreen.orientation = 'portrait';
    }
    else
    {
        w_myScreen.orientation = 'landscape';
    }

    // check space in columns
    if(w_myScreen.layout === 'desktop')
    {
        adjust_columns();
    }
    else
    {
        fix_columns();
        Lightbox.adjust_height();
    }

/*
    if(firstRun === true)
    {
        w_myScreen.remLayout = w_myScreen.layout;
    }
    else if(w_myScreen.remLayout !== w_myScreen.layout)
    {
        window.location.reload(true);
    }
 */
};

const get_elInfo = function(el)
{
    return el.getBoundingClientRect(document.body);
};

const highlight_dates = function(el)
{
    const myDate = el.href.slice(-10),
          firstEl = document.body.querySelector('#w--main .w__tile[data-date="' + myDate + '"]');

    if(firstEl && firstEl.closest('.w__details'))
    {
        firstEl.closest('.w__details').setAttribute('open','');
    }

    let tiles = document.body.querySelectorAll('#w--main .w__tile.w__highlight');

    for(let i=0; i<tiles.length; i++)
    {
        tiles[i].classList.remove('w__highlight');
    }

    tiles = document.body.querySelectorAll('#w--main .w__tile[data-date="' + myDate + '"]');

    for(let i=0; i<tiles.length; i++)
    {
        tiles[i].classList.add('w__highlight');
    }
};

const adjust_columns = function()
{
    let unfix = false;
    const nav = document.getElementById('w--nav'),
          context = document.getElementById('w--context'),
          mainMenu = nav.querySelector('.w__menu--main li:nth-child(3) .w__menu--level-2'),
          socialMenu = nav.querySelector('.w__menu--social'),
          legalMenu = nav.querySelector('.w__menu--legal');

    if(get_elInfo(socialMenu)['height'] + get_elInfo(mainMenu)['bottom'] + 50 > w_myScreen.y)
    {
        unfix = true;
    }

    if(context && unfix === false)
    {
        const contextMenu = context.querySelector('.w__menu--context');

        if(contextMenu &&
           legalMenu &&
           get_elInfo(legalMenu)['height'] + (get_elInfo(contextMenu)['bottom'] + 50) > w_myScreen.y)
        {
            unfix = true;
        }
    }

    // check space in columns
    if(unfix === true)
    {
        document.body.classList.add('w__unfix');
        const myHeight = (document.documentElement.scrollHeight || document.body.scrollHeight) + 'px';
        nav.style.height = myHeight;
        document.getElementById('w--overlay-1').style.height = myHeight;
        if(document.getElementById('w--overlay-2'))
        {
            document.getElementById('w--overlay-2').style.height = myHeight;
        }
    }
    else
    {
        fix_columns();
    }
};

const do_onScroll = function()
{
    if(document.body.classList.contains('w__unfix'))
    {
        const scrollY = window.scrollY || window.pageYOffset,
              offset = 2500 - w_myScreen.y;

        if(scrollY >= offset)
        {
            document.getElementById('w--overlay-1').style.position = 'fixed';
            document.getElementById('w--overlay-1').style.top = (offset * -1).toString() + 'px';
            if(document.getElementById('w--overlay-2'))
            {
                document.getElementById('w--overlay-2').style.position = 'fixed';
                document.getElementById('w--overlay-2').style.top = (offset * -1).toString() + 'px';
            }
        }
        else
        {
            const reset = (w_myBrowser.engine === 'trident') ? '' : null;
            document.getElementById('w--overlay-1').style.position = reset;
            document.getElementById('w--overlay-1').style.top = reset;
            document.getElementById('w--overlay-1').style.bottom = reset;
            if(document.getElementById('w--overlay-2'))
            {
                document.getElementById('w--overlay-2').style.position = reset;
                document.getElementById('w--overlay-2').style.top = reset;
                document.getElementById('w--overlay-2').style.bottom = reset;
            }
        }
    }
}

const fix_columns = function()
{
    if(w_myBrowser.mobile === false)
    {
        document.body.classList.remove('w__unfix');
        document.getElementById('w--nav').removeAttribute('style');
        document.getElementById('w--overlay-1').removeAttribute('style');
        if(document.getElementById('w--overlay-2'))
        {
            document.getElementById('w--overlay-2').removeAttribute('style');
        }
    }
};

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(w_resizeTimer);
    w_resizeTimer = requestAnimationFrame(get_screenSize);
});

// window scroll detection
window.addEventListener('scroll',() =>
{
    cancelAnimationFrame(w_scrollTimer);
    w_scrollTimer = requestAnimationFrame(do_onScroll);
});